import { Directive, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ILookup } from '../shared/lookup';

@Directive()
export abstract class ProjectItemComponent {
    
    @Input('group')
    public projectItemForm: FormGroup;
    @Input('count')
    public count: number;
    @Input('current')
    public current: number;
    @Input('lookup')
    public lookup: ILookup[];
    @Output() addItem = new EventEmitter()
    @Output() removeItem = new EventEmitter()


    addProjectItem() {
        this.addItem.emit();
        return false;
    }

    removeProjectItem() {
        this.removeItem.emit();
        return false;
    }

}